import {
  Box,
  Grid,
  Typography,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { toast } from "react-toastify";

const ClientDetails = ({
  formData,
  setFormData,
  isEditing,
  setIsEditing,
  clientDetails,
  handleSave,
  user,
}) => {
  const isAdmin = user?.role === "admin";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target?.value });
  };

  const handleColorChange = (color, field) => {
    setFormData((prev) => ({ ...prev, [field]: color.hex }));
  };
  const handleUpdate = async () => {
    try {
      await handleSave();
      setIsEditing(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: "8px",
        marginTop: "20px",
        padding: "20px",
        backgroundColor: "var(--bg-paper)",
        width: "99%",
        position: "relative",
        borderBottom: "0.5px solid var(--border-color)",
      }}
    >
      <Grid container spacing={2}>
        {isAdmin ? (
          <>
            {/* Name */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  sx={{
                    textAlign: "start",
                    fontFamily: "poppins",
                    fontWeight: 500,
                  }}
                >
                  Name
                </Typography>
              </Grid>
              <Grid item xs={7}>
                {isEditing ? (
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography
                    style={{
                      color: "var(--text-primary)",
                      fontWeight: "500",
                      fontFamily: "poppins",
                      textAlign: "start",
                    }}
                  >
                    : {formData.name}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/* Email */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  color={"var(--text-primary)"}
                  style={{
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                  variant="body1"
                >
                  Email
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography
                  style={{
                    color: "var(--text-primary)",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    textAlign: "start",
                    overflowWrap: "break-word",
                  }}
                >
                  :&nbsp;{user.email}
                </Typography>
              </Grid>
            </Grid>

            {/* Role */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  color={"var(--text-primary)"}
                  style={{
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                  variant="body1"
                >
                  Role
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography
                  style={{
                    color: "var(--text-primary)",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    textAlign: "start",
                    overflowWrap: "break-word",
                  }}
                >
                  :&nbsp;{user.role}
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            {/* Client Name */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  sx={{
                    textAlign: "start",
                    fontFamily: "poppins",
                    fontWeight: 500,
                  }}
                >
                  Client Name
                </Typography>
              </Grid>
              <Grid item xs={7}>
                {isEditing ? (
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography
                    style={{
                      color: "var(--text-primary)",
                      fontWeight: "500",
                      fontFamily: "poppins",
                      textAlign: "start",
                    }}
                  >
                    : {formData.name}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/* Client UID */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  color={"var(--text-primary)"}
                  style={{
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                  variant="body1"
                >
                  Client UID
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography
                  style={{
                    color: "var(--text-primary)",
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                >
                  : {clientDetails?.client_uid}
                </Typography>
              </Grid>
            </Grid>

            {/* Email */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  color={"var(--text-primary)"}
                  style={{
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                  variant="body1"
                >
                  Email
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography
                  style={{
                    color: "var(--text-primary)",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    textAlign: "start",
                    overflowWrap: "break-word",
                  }}
                >
                  :&nbsp;{formData?.email}
                </Typography>
              </Grid>
            </Grid>

            {/* Mobile Number */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  color={"var(--text-primary)"}
                  style={{
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                  variant="body1"
                >
                  Mobile Number
                </Typography>
              </Grid>
              <Grid item xs={7}>
                {isEditing ? (
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="contact"
                    value={formData.contact}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography
                    style={{
                      color: "var(--text-primary)",
                      fontWeight: "500",
                      fontFamily: "Poppins",
                      textAlign: "start",
                      overflowWrap: "break-word",
                    }}
                  >
                    :&nbsp;{formData.contact}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/* Business Name */}
            <Grid item container>
              <Grid item xs={5}>
                <Typography
                  color={"var(--text-primary)"}
                  style={{
                    fontWeight: "500",
                    fontFamily: "poppins",
                    textAlign: "start",
                  }}
                  variant="body1"
                >
                  Business Name
                </Typography>
              </Grid>
              <Grid item xs={7}>
                {isEditing ? (
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    name="business_name"
                    value={formData.business_name}
                    onChange={handleChange}
                  />
                ) : (
                  <Typography
                    style={{
                      color: "var(--text-primary)",
                      fontWeight: "500",
                      fontFamily: "Poppins",
                      textAlign: "start",
                      overflowWrap: "break-word",
                    }}
                  >
                    :&nbsp;{formData.business_name}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/* Color Settings */}
            {[
              { key: "primary_color", label: "Primary Color" },
              { key: "secondary_color", label: "Secondary Color" },
              { key: "text_color", label: "Text Color" },
            ].map(({ key, label }) => (
              <Grid item container key={key}>
                <Grid item xs={5}>
                  <Typography
                    color={"var(--text-primary)"}
                    style={{
                      fontWeight: "500",
                      fontFamily: "poppins",
                      textAlign: "start",
                    }}
                    variant="body1"
                  >
                    {label}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  {isEditing ? (
                    <TextField
                      type="color"
                      size="small"
                      fullWidth
                      variant="outlined"
                      name={key}
                      value={formData[key]}
                      onChange={(e) =>
                        handleColorChange({ hex: e.target.value }, key)
                      }
                      sx={{ '& input[type="color"]': { width: "100%" } }}
                    />
                  ) : (
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid var(--border-color)",
                        width: 36,
                        marginLeft: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          height: 30,
                          width: 30,
                          backgroundColor: formData[key],
                        }}
                      ></div>
                    </div>
                  )}
                </Grid>
              </Grid>
            ))}
          </>
        )}

        {!isEditing && (
          <Grid item xs={2} sx={{ position: "absolute", right: 1, top: -15 }}>
            <IconButton onClick={() => setIsEditing(true)}>
              <DriveFileRenameOutlineIcon sx={{ color: "primary.main" }} />
            </IconButton>
          </Grid>
        )}
      </Grid>

      {isEditing && (
        <Box
          sx={{
            margin: 2,
            width: "95%",
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <Button
            style={{ marginRight: 15, color: "red", borderColor: "red" }}
            variant="outlined"
            onClick={() => setIsEditing(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleUpdate}>
            Update
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ClientDetails;
